import script from "./deboneInventory.vue?vue&type=script&setup=true&lang=js"
export * from "./deboneInventory.vue?vue&type=script&setup=true&lang=js"

import "./deboneInventory.vue?vue&type=style&index=0&id=2f3fe12b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f3fe12b"]])

export default __exports__